import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import * as utilsDocument from "../utils/document";

const initialState = {
    fogs: [],
    generating: false,
    current: null,
    loading: false,
    saving: false,
    duplicating: false,
    formData: {}
};

export default function fog(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_FOG:
            newState.loading = true;
            break;

        case actions.SAVING_FOG:
            newState.saving = true;
            break;

        case actions.SAVING_VESSEL:
            newState.saving = true;
            break;

        case actions.DUPLICATING_FOG:
            newState.duplicating = true;
            break;

        case actions.DONE_DUPLICATING_FOG:
            newState.duplicating = false;
            break;

        case actions.SAVED_VESSEL:
            newState.saving = false;
            break;

        case actions.RECEIVED_FOGS:
            newState.fogs = utils.mapById(action.payload);
            for (let i = 0; i < newState.fogs.length; i++) {
                newState.fogs[i].sortedDocuments = utilsDocument.sortDocuments(newState.fogs[i].original.documents);
            }

            newState.loading = false;
            break;

        case actions.RECEIVED_FOG:
            let found = false;

            for (let i = 0; i < newState.fogs.length; i++) {
                if(newState.fogs[i].id === action.payload.id){
                    found = true;
                    newState.fogs[i] = {...action.payload, sortedDocuments: utilsDocument.sortDocuments(action.payload.original.documents)};
                }
            }

            if(!found) {
                newState.fogs.add(
                    action.payload
                );
            }
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.SAVED_FOG:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_FOG:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.GENERATING_DOCUMENT:
            newState.generating = true;
            break;

        case actions.DONE_GENERATING_DOCUMENT:
            newState.generating = false;
            break;

        case actions.ERROR_GENERATING_DOCUMENT:
            newState.generating = false;
            break;

        case actions.CANCEL_DOCUMENT:
            newState.generating = true;
            break;

        case actions.DONE_CANCEL_DOCUMENT:
            newState.generating = false;
            break;

        case actions.ERROR_CANCEL_DOCUMENT:
            newState.generating = false;
            break;

        case actions.UPDATEDATAFORM_FOG:
            newState.formData = action.payload.formData;
            break;

        case actions.CLEARDATAFORM_FOG:
            newState.formData = {};
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/fog.js